import { useEffect, useState } from 'react';
import StatisticsService from '../../service/StatisticsService';
import { statisticsDropdown } from '../../common/initialValues/initialValues';

import ArrowDownIcon from '../../assets/icons/arrow-down-orange-icon.svg';
import { Statistics } from '../../common/types/types';
import { LineGraph } from '../../components/graphs/Line';
import { BarGraph } from '../../components/graphs/BarChart';
import { PieChart } from '../../components/graphs/Pie';
import { DocumentsByProcessIdTable } from '../../components/statistics/DocumentsByProcessIdTable';

export const StatisticsComponent = () => {
  const [timeFrame, setTimeFrame] = useState('week');

  const [dropdownActive, setDropdownActive] = useState(false);

  const [statistics, setStatistics] = useState<Statistics>();

  useEffect(() => {
    StatisticsService.getStatistics({ time_frame: timeFrame, start_date: null, end_date: null }).then((response) => {
      setStatistics(response.data);
    });
  }, [timeFrame]);

  //Transfering documents by process id to table format
  const originalObject = statistics?.documentsByProcessType || {};
  const documentsByProcessIdTransformed = Object.entries(originalObject).map(([processTypeId, amount]) => {
    return { processTypeId: processTypeId, amount: amount.toString() };
  });
  //----------------------------------------------------

  return (
    <div className='simplydoc-page margin-bottom-5'>
      <div className='simplydoc-page__section-one'>
        <h1 className='font-h1-regular color-white'>Statistics</h1>
      </div>
      <div className='simplydoc-page__section-two padding-right-0 font-h5-medium'>
        <span>Showing:</span>
        <div className={`${dropdownActive ? 'open' : ''} dropdown-custom pointer`} onClick={() => setDropdownActive((prevState) => !prevState)}>
          <span className='dropdown-custom__selected'>{statisticsDropdown.find((item) => item.key === timeFrame)?.label}</span>
          <img className='dropdown-custom__arrow-img' src={ArrowDownIcon} alt='' />
          <div className={`${dropdownActive ? '' : 'hide'} dropdown-custom__dropdown`}>
            {statisticsDropdown.map((item) => {
              return (
                <span
                  key={item.key}
                  className={`dropdown-custom__item font-h5-regular ${item.key === timeFrame ? 'active' : ''}`}
                  onClick={() => setTimeFrame(item.key)}
                >
                  {item.label}
                </span>
              );
            })}
          </div>
        </div>
      </div>
      <div className='statistics-numbers'>
        <div>
          <h3>{statistics?.documentsUploaded}</h3>
          <span className='font-h5-regular dark-400'>files uploaded</span>
        </div>
        <div>
          <h3>{statistics?.documentsArchived}</h3>
          <span className='font-h5-regular dark-400'>files archived</span>
        </div>
        <div>
          <h3>{statistics?.documentsDeleted}</h3>
          <span className='font-h5-regular dark-400'>files deleted</span>
        </div>
      </div>

      {timeFrame === 'year' ? <LineGraph statistics={statistics?.timeline.year} title={'Files prosessed'} /> : <></>}
      {timeFrame === 'month' ? <LineGraph statistics={statistics?.timeline.month} title={'Files prosessed'} /> : <></>}
      {timeFrame === 'week' ? <LineGraph statistics={statistics?.timeline.week} title={'Files prosessed'} /> : <></>}
      <BarGraph statistics={statistics?.documentsByProcessType} title={'Documents by process type'} />

      <div className='graph-custom-box-1'>
        <div className='width-50perc'>
          <PieChart statistics={statistics?.documentsByUser} title={'Documents per user'} />
        </div>
        <DocumentsByProcessIdTable tableData={documentsByProcessIdTransformed} />
      </div>
    </div>
  );
};
